import $ from "jquery"
import ScrollMagic from "scrollmagic";
import {debounce, find} from "lodash";
import {breakpointDown} from "./Breakpoints";
import Scrolling from "../libs/Scrolling"

import C2CVue from "./vue"

export default {
    menuOpen: false,
    menuScene: null,
    controller: new ScrollMagic.Controller(),
    init() {

        $("nav.main-menu button").on("click", (e) => {
            if (this.menuOpen) {
                this.closeMenu()
            } else {
                this.openMenu()
            }
            e.preventDefault()
        });

        $("nav.main-menu a").on("click", (e) => {
            this.closeMenu()
        });

        $("nav.main-menu .background-mask").on("click", (e) => {
            this.closeMenu()
        })


        $(".main-menu .menu a").on("click", (event) => {
            this.handleHashLinks(event)
        })

    },
    handleHashLinks(event) {
        if ($("body").hasClass("home")) {
            let url = event.currentTarget.href
            if (url.indexOf("#") !== -1) {

                let slug = url.substring(url.indexOf("#") + 1)

                if (breakpointDown("md")) {
                    Scrolling.scrollTo("#" + slug)

                } else {

                    let selectedSlide = find(C2CVue.vueInstance.$refs["hp-transitions"].items, (o, index) => {
                        return o.slug === slug
                    });
                    C2CVue.vueInstance.$refs["hp-transitions"].slideManager(null, selectedSlide.index)

                }


            }
        }
    },
    openMenu() {

        $("nav.main-menu button").addClass("is-active")
        $("nav.main-menu").addClass("open").addClass("z-index")
        this.menuOpen = true;
        if (breakpointDown("md")) {
            $("html").addClass("no-scroll")
        }
    },
    closeMenu() {
        $("nav.main-menu button").removeClass("is-active")
        $("nav.main-menu").removeClass("open")
        this.menuOpen = false;
        $("html").removeClass("no-scroll")
    },
    initMenuSticky() {

        // Scene Bouton Menu Switch
        this.menuScene = new ScrollMagic.Scene({
            triggerElement: "body",
            triggerHook: 0,
            duration: 0,    // the scene should last for a scroll distance of
                            // 100px
            offset: 5,        // start this scene after scrolling for 50px
        })
        // .addIndicators()
            .addTo(this.controller)
            .on("update", (e) => {
                var direction = this.controller.info("scrollDirection");
                console.log(direction)
                let hideOkToggle = (e.scrollPos >= e.startPos);
                console.log(hideOkToggle)
                this.scrollPos = e.scrollPos;

                if (direction === "FORWARD") {
                    $(".main-menu").addClass("hide")
                } else {
                    $(".main-menu").removeClass("hide")
                }


            }); // assign the scene to the controller

    }
};